import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import {
  getNewIcons,
  SetFontSize,
  ZeeFontMedium,
  ZeeFontRegular
} from 'src/styles/font';
import { NewIconsSet } from 'src/utils/constants/IconsConstants';

export const shareContainer = css`
  z-index: 1;
`;

export const shareIcon = css`
  ${getNewIcons(NewIconsSet.SHARE)};
  color: ${colors.PrimaryWhiteColor};
  cursor: pointer;
  font-size: 28px;
  padding: 16px 32px 22px 40px;
  background: ${colors.PrimaryWhiteColorAlpha04};
`;

export const shareLable = css`
  ${ZeeFontRegular(18, 22)};
  color: ${colors.Transparent};
  padding-top: 10px;
`;
export const shareButton = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${colors.white};
  border-radius: 4px;
  padding: 5px 10px;
  color: ${colors.Gray4F};
  ${ZeeFontMedium(11)}
  z-index:1;
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  &:hover {
    color: ${colors.Purple};
    border-color: ${colors.Purple};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;

export const shareIconForThumbnail = css`
  ${SetFontSize(15)}
  margin-right: 3px;
  display: flex;
  ${getNewIcons(NewIconsSet.SHARE)}
  &:before {
    content: '%';
  }
`;
